module.exports = __webpack_public_path__ + "static/media/duplicated.613716da.png";